import dayjs from "./configuredDayjs";

export function formatTestSendSubject(
  subject: string,
  now: Date = new Date(),
): string {
  const timestamp = dayjs(now).format("MM.DD.YYYY hh:mm A");
  return `[TEST ${timestamp}] ${subject}`;
}
